"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseViewSchema = void 0;
const baseSchema_1 = __importDefault(require("./baseSchema"));
class BaseViewSchema extends baseSchema_1.default {
    constructor({ arrivedFrom }) {
        super();
        this.arrivedFrom = arrivedFrom;
        this.pushKind = 'NOT_PUSH_EVENT';
    }
    prepare() {
        return {
            ...super.prepare(),
            arrivedFrom: this.arrivedFrom,
            pushKind: this.pushKind
        };
    }
}
exports.BaseViewSchema = BaseViewSchema;
